import { Box, Heading, Link, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { WithLayout } from './WithLayout';

import { urlBuilder } from '../../Shared/urlBuilder';
import { useNotFoundLogger } from '../hooks/useNotFoundLogger';

export function NotFound() {
  useNotFoundLogger();

  return (
    <WithLayout parts={{ sidebar: true }}>
      <Box css={{ height: '100vh', display: 'grid' }}>
        <Heading variant="brandTitle" css={{ paddingLeft: 'space.300', paddingTop: 'space.150' }}>
          Betterment
        </Heading>
        <Box
          css={{
            display: 'flex',
            justifySelf: 'center',
            flexDirection: 'column',
            textAlign: 'center',
            maxWidth: 'breakpoint-md',
          }}
        >
          <Text as="div" variant="text400" css={{ marginBottom: 'space.400' }}>
            The page you requested could not be found.
          </Text>
          <Text css={{ marginBottom: 'space.100' }}>
            Please enter a valid address or return to{' '}
            <SambaAutoLink to={urlBuilder.appHome.absolute()}>home</SambaAutoLink>.
          </Text>
          <Text>
            As always, your money is safe and secure. If you have any questions, please contact our support team at{' '}
            <Link href="mailto:support@betterment.com">support@betterment.com</Link> or (646) 600-8263.
          </Text>
        </Box>
      </Box>
    </WithLayout>
  );
}
